import React, { useEffect, useState } from "react";
import AxiosInstance from "../authorization/AxiosInstance";
import ImageUploader from "./ImageUploader";

export default function HeroAdmin() {
  const [form, setForm] = useState({ title: "", subtitle: "", buttonText: "", buttonLink: "", imageUrl: "" });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    AxiosInstance.get("/hero-config")
      .then(r => setForm({
        title: r.data.title || "",
        subtitle: r.data.subtitle || "",
        buttonText: r.data.buttonText || "",
        buttonLink: r.data.buttonLink || "",
        imageUrl: r.data.imageUrl || "",
      }))
      .catch(() => setError("Failed to load hero config"))
      .finally(() => setLoading(false));
  }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSave = async () => {
    setSaving(true); setError(null); setSuccess(false);
    try {
      await AxiosInstance.patch("/hero-config", form);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (e) {
      setError(e?.response?.data?.message || "Save failed");
    } finally { setSaving(false); }
  };

  const cls = "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400";

  return (
    <div>
      <h2 className="text-xl font-bold text-gray-800 mb-6">Hero Section</h2>

      {loading ? <div className="text-gray-400 text-sm">Loading…</div> : (
        <div className="bg-white rounded-xl shadow p-6 max-w-xl">
          {error && <div className="mb-4 text-red-600 text-sm">{error}</div>}
          {success && <div className="mb-4 text-green-600 text-sm font-medium">Saved successfully.</div>}

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Title <span className="text-gray-400 font-normal">(use \n for line breaks)</span>
            </label>
            <textarea name="title" value={form.title} onChange={handleChange} rows={3} className={cls} />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Subtitle</label>
            <input name="subtitle" value={form.subtitle} onChange={handleChange} className={cls} />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Button Text</label>
            <input name="buttonText" value={form.buttonText} onChange={handleChange} className={cls} />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Button Link</label>
            <input name="buttonLink" value={form.buttonLink} onChange={handleChange} className={cls} placeholder="/login" />
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Background Image <span className="text-gray-400 font-normal">(leave blank for default)</span>
            </label>
            <ImageUploader
              value={form.imageUrl}
              onChange={(url) => setForm(f => ({ ...f, imageUrl: url }))}
              folder="hero"
            />
          </div>

          <button
            onClick={handleSave}
            disabled={saving}
            className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-6 py-2 rounded-lg disabled:opacity-50"
          >
            {saving ? "Saving…" : "Save Changes"}
          </button>
        </div>
      )}
    </div>
  );
}
